import { AGeneralActionCreator } from '@ispm/core/classes/general-action-creator.abstract';
import { WorkflowDrivenCacheablesEntity } from '@ispm/workflow/entities/workflow-driven-cacheables.entity';
import { cacheActionCreator } from '@ispm/core/utils/store.util';
import { CORE_ACTIONS } from '@ispm/core/constants/core-actions.constant';

export abstract class AWorkflowDrivenAction<T = any> extends AGeneralActionCreator {
  // the action which should be applied
  public callbackType: string;
  // placeholder for the CAST_ACTION
  private readonly _type: string;

  set type(type: string ) {
    if (!this.callbackType) {
      this.callbackType = type;
      // set cast action as 'type' so redux-devtool will display the action
      // otherwise Undefined will be displayed
      Object.defineProperty(this, 'type', {value: this._type, enumerable: true, configurable: true});

    }
  }

  protected constructor(payload: T) {
    super(payload);
    this._type = CORE_ACTIONS.CAST_ACTION;
    this.payload = WorkflowDrivenCacheablesEntity.builder(payload).setIdentifier();
  }

}


